import apiClient from "../client.js";
import { API_URLS } from "../urls.js";

// Get all agents
export const getAgents = () =>
  apiClient.get(API_URLS.AGENTS.LIST).then((res) => res.data);

// Get single agent
export const getAgent = (id) =>
  apiClient.get(API_URLS.AGENTS.DETAIL(id)).then((res) => res.data);

// Create agent
export const createAgent = (data) =>
  apiClient.post(API_URLS.AGENTS.CREATE, data).then((res) => res.data);

// Update agent
export const updateAgent = (id, data) =>
  apiClient.patch(API_URLS.AGENTS.UPDATE(id), data).then((res) => res.data);

// Delete agent
export const deleteAgent = (id) =>
  apiClient.delete(API_URLS.AGENTS.DELETE(id)).then((res) => res.data);

export const toggleAgentStatus = (agentId) =>
  apiClient.patch(API_URLS.AGENTS.STATUS(agentId)).then((res) => res.data);

// Get agent properties
export const getAgentProperties = (agentId) =>
  apiClient
    .get(API_URLS.PROPERTIES.LIST_BY_AGENT(agentId))
    .then((res) => res.data);

// Get all domains for an agent
export const getDomains = (agentId) =>
  apiClient.get(API_URLS.AGENTS.DOMAINS(agentId)).then((res) => res.data);

// Get single domain
export const getDomain = (agentId, domain) =>
  apiClient
    .get(API_URLS.AGENTS.DOMAIN_DETAIL(agentId, domain))
    .then((res) => res.data);

// Create domain
export const createDomain = (agentId, data) =>
  apiClient
    .post(API_URLS.AGENTS.DOMAINS(agentId), data)
    .then((res) => res.data);

// Update domain
export const updateDomain = (agentId, domain_id, data) =>
  apiClient
    .patch(API_URLS.AGENTS.DOMAIN_UPDATE(agentId, domain_id), data)
    .then((res) => res.data);

// Delete domain
export const deleteDomain = (agentId, domain) =>
  apiClient
    .delete(API_URLS.AGENTS.DOMAIN_DETAIL(agentId, domain))
    .then((res) => res.data);

    // Get widget settings
    export const getWidgetSettings = (agentId) =>
      apiClient.get(API_URLS.AGENTS.WIDGET_SETTINGS(agentId)).then((res) => res.data);

    export const manageWidgetSettings = (agentId, data) =>
      apiClient.post(API_URLS.AGENTS.WIDGET_SETTINGS(agentId), data).then((res) => res.data);

    export const deleteWidgetSettings = (agentId) =>
      apiClient.delete(API_URLS.AGENTS.WIDGET_SETTINGS(agentId)).then((res) => res.data);
